<template>
  <div class="wechatProduct-operation-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span v-if="$route.query.id">编辑</span>
        <span v-else>新增</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'wechatProduct' })"
        >
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="save">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="100px"
          @submit.native.prevent
          :model="formData"
          ref="ruleForm"
          label-position="top"
          :rules="rules"
        >
          <el-form-item label="产品名称" prop="name">
            <el-input v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item label="产品型号" prop="model">
            <el-input v-model="formData.model"></el-input>
          </el-form-item>
          <el-form-item label="产品ID" prop="product_id">
            <el-input v-model="formData.product_id"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import OSS from "ali-oss";
import { mapGetters } from "vuex";

export default {
  components: {
    editor: Editor,
  },
  computed: {
    ...mapGetters(["buckets"]),
  },
  data() {
    return {
      formData: {
        name: "",
        model: "",
        product_id: "",
        capability: "发消息到设备",
        category: "娱乐影音 / 平板",
        join_type: "云快速接入",
        status: "development",
      },
      params: {},
      rules: {},
    };
  },
  methods: {
    async getwechatProductDetails() {
      let res = await this.$http.getIotProductsDetails(this.$route.query.id);
      this.formData = Object.assign(this.formData, res.data);
    },

    save() {
      this.params = Object.assign({}, this.formData);

      if (this.$route.query.id) {
        this.edit();
      } else {
        this.create();
      }
    },

    async create() {
      await this.$http.createIotProducts(this.params);
      this.elMsg("操作成功", "success");
      this.$router.push({ name: "wechatProduct" });
    },

    async edit() {
      await this.$http.updateIotProducts(this.$route.query.id, this.params);
      this.elMsg("操作成功", "success");
      this.$router.push({ name: "wechatProduct" });
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.getwechatProductDetails();
    }
  },
};
</script>

<style lang="scss">
.wechatProduct-operation-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
    .pic {
      .pic-item {
        /* position: relative; */
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .global-button-style {
        width: 80px;
        height: 30px;
      }
      .wechatProduct-operation-edit-cover {
        position: relative;
        width: 200px;
        height: 300px;
        overflow: hidden;
        margin: 10px 0;
        border: 2px dashed #ccc;
        border-radius: 10px;
        &:hover {
          border-color: #bb745c;
        }
        > img {
          width: 100%;
          height: 100%;
        }
        > .wechatProduct-operation-edit-cover-icon {
          font-weight: bold;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #bb745c;
        }
        > .wechatProduct-operation-edit-upload {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.2s;
          &:hover {
            transition: all 0.2s;
            background: rgba($color: #000000, $alpha: 0.4);
            .wechatProduct-operation-edit-upload-btn {
              display: block;
            }
          }
          .wechatProduct-operation-edit-upload-btn {
            width: 100%;
            height: 100%;
            display: none;
            cursor: pointer;
            color: #fff;
            font-weight: bold;
            position: absolute;
            text-align: center;
            line-height: 300px;
            > .el-upload--text {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .add-img {
        width: 70px;
        height: 40px;
        font-size: 22px;
        line-height: 43px;
        color: #fff;
        cursor: pointer;
        background-color: #bb745c;
      }
    }
  }
}
</style>
